// 城市简称
export const cityName = [
  '京',
  '津',
  '晋',
  '冀',
  '蒙',
  '辽',
  '吉',
  '黑',
  '沪',
  '苏',
  '浙',
  '皖',
  '闽',
  '赣',
  '鲁',
  '豫',
  '鄂',
  '湘',
  '粤',
  '桂',
  '琼',
  '渝',
  '川',
  '贵',
  '云',
  '藏',
  '陕',
  '甘',
  '青',
  '宁',
  '新'
];

// 性别
export const sexText = sex => sex === 1 ? '男' : '女';

// 房屋认证状态
export const houseCertificateStatusText = status => status === 2 ? '已驳回' : (status === 3 ? '待确认' : (status === 4 ? '已认证' : '待审核'));

// 车位租售状态
export const parkingStatusText = status => status === 1 ? '出售' : (status === 2 ? '出租' : '闲置');

// 房屋属性
export const houseTypeText = status => status === 1 ? '住宅' : (status === 2 ? '商住' : '还迁');

// 房屋状态
export const houseStatusText = status => status === 1 ? '待售' : (status === 2 ? '已售' : (status === 3 ? '收房' : (status === 4 ? '装修' : (status === 5 ? '自住' : (status === 6 ? '出租' : '闲置')))));

// 房屋身份
export const houseIdentityText = status => status === 1 ? '产权人' : (status === 2 ? '家属' : '租户');

// 公告状态
export const noticeText = status => status === 1 ? '待发布' : (status === 2 ? '已发布' : '已下线');

// 社区活动 活动状态
export const activityStatusText = status => status === 1 ? '未开始' : (status === 2 ? '活动中' : '已结束');

// 物业报修 维修角色
export const repairPeopleRoleText = status => status === 1 ? '维修队长' : '维修师傅';

// 物业报修 工单状态
export const repairOrderStatusText = status => status === 1 ? '待处理' : (status === 2 ? '待上门' : (status === 3 ? '维修中' : (status === 4 ? '待支付' : (status === 5 ? '已完成' : (status === 6 ? '已取消' : '已支付')))));

// 费项管理 计费周期
export const paymentCycleStatusText = status => status === 1 ? '按月计算' : (status === 2 ? '按季计算' : (status === 3 ? '按年计算' : '一次性收缴'));

// 费项管理 计算周期
export const caculatePeriodStatusText = status => status === 1 ? '按日计算' : (status === 2 ? '按月计算' : (status === 3 ? '按季计算' : '按年计算'));

// 应收订单状态
export const receiveOrderStatusText = status => status === 1 ? '未缴' : (status === 2 ? '已缴' : '作废');

// 应收订单缴费方式
export const receiveOrderPayStatusText = status => status === 1 ? '现金' : '';

// 访客状态
export const visitorStatusText = status => status === 1 ? '已到访' : '未到访';

// 车辆状态
export const carStatusText = status => status === 0 ? '待审核' : (status === 1 ? '已审核' : '已驳回');

// 积分周期范围
export const integralStatusText = status => status === 1 ? '每日' : (status === 2 ? '每周' : (status === 3 ? '每年' : '一次性'));

// 设备类型
export const deviceTypeText = type => type === 1 ? '管理机' : (type === 2 ? '围墙机' : (type === 3 ? '单元机' : (type === 4 ? '门口机' : (type === 10 ? '普通固定机' : (type === 14 ? '数字室内机' : '未知设备')))));

// 开锁类型
export const unlockTypeText = v => {
  switch (v) {
    case 'remoteOpen':
      return '远程开门'
    case 'face':
      return '人脸识别'
    case 'qrCode':
      return '二维码'
    case 'tradCard':
      return '传统卡'
    case 'bleCard':
      return '蓝牙'
    case 'password':
      return '密码'
    default:
      return ''
  }
}

// 开锁人员类型
export const unlockPersonTypeText = type => type === 1 ? '业主' : (type === 2 ? '物业人员' : '访客');

// 设备管理 设备品牌
export const equipBrand = brand => brand === 1 ? '海康' : (brand === 2 ? '大华' : (brand === 3 ? '捷顺' : (brand === 4 ? '科拓' : (brand === 5 ? '商汤' : '富士'))));

// 设备管理 设备类型
export const deviceTypes = type => type === 1 ? '水表' : (type === 2 ? '电表' : (type === 3 ? '监控' : (type === 4 ? '水泵' : (type === 5 ? '道闸' : '门禁'))));

//运行状态
export const runningStatus = status => status === 0 ? '设备停用' : '正常运行';

//任务状态
export const taskStatus = status => status === 0 ? '未开始' : (status === 1 ? '进行中' : '已结束');

//巡检周期
export const checkCycle = cycle => cycle === 1 ? '天' : (cycle === 2 ? '周' : (cycle === 3 ? '月' : '年'));

//维保等级
export const mainLevel = level => level === 1 ? '日常维保' : (level === 2 ? '一级维保' : (level === 3 ? '二级维保' : (level === 4 ? '三级维保' : '四级维保')));

//厂商类型
export const manuType = type => type === 1 ? '生产商' : '维保商';

//巡检状态
export const patioStatus = status => status === 1 ? '待巡查' : (status === 2 ? '已巡查' : '已过期');